(() => {
'use strict';
const select = document.getElementById('dl-display-currency');
if (!select) return;
const fallback = {"USD":94.18370454978108,"EUR":105.67804565820354,"GBP":125.51821862348179,"AED":24.916807049371517,"SAR":24.38135485672225,"CAD":66.04659738518271,"AUD":65.25149065853982,"NZD":52.82131324004306,"CHF":114.233924867481,"SGD":73.22251911229867,"HKD":11.101556260135053,"INR":1};
const codes = Object.keys(fallback);
let divisors = {...fallback};
let currency = 'USD';
const preferenceKey = 'driplocker-display-currency-v1';
const cacheKey = 'driplocker-display-fx-v1';
try {
 const saved = localStorage.getItem(preferenceKey);
 if (codes.includes(saved)) currency = saved;
 const cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
 if (cached && cached.expires > Date.now() && codes.every(c => Number.isFinite(cached.divisors[c]) && cached.divisors[c] > 0)) divisors = cached.divisors;
} catch {}
select.value = currency;
const records = new Map();
const moneyPattern = /(?:Rs\.?\s*|₹\s*|INR\s*)(\d[\d,]*(?:\.\d{1,2})?)(?:\s*INR)?/g;
const excluded = 'script,style,noscript,textarea,input,select,option,#dl-currency-bar,iframe';
let timer = null;
let observer;
const format = amount => new Intl.NumberFormat('en-US', {style:'currency',currency,currencyDisplay:'code',minimumFractionDigits:2,maximumFractionDigits:2}).format(amount / divisors[currency]);
function refresh() {
 observer?.disconnect();
 const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
  acceptNode(node) {
   if (!node.parentElement || node.parentElement.closest(excluded)) return NodeFilter.FILTER_REJECT;
   return NodeFilter.FILTER_ACCEPT;
  }
 });
 for (let node=walker.nextNode(); node; node=walker.nextNode()) {
  let entry = records.get(node);
  if (entry && node.nodeValue !== entry.rendered) { records.delete(node); entry=null; }
  if (!entry) {
   moneyPattern.lastIndex=0;
   if (!moneyPattern.test(node.nodeValue || '')) continue;
   entry = {source:node.nodeValue,rendered:node.nodeValue};
   records.set(node,entry);
  }
  moneyPattern.lastIndex=0;
  const output = currency === 'INR' ? entry.source : entry.source.replace(moneyPattern, (_,number) => format(Number(number.replace(/,/g,''))));
  if (node.nodeValue !== output) node.nodeValue=output;
  entry.rendered=output;
 }
 for (const node of records.keys()) if (!node.isConnected) records.delete(node);
 observer?.observe(document.body,{childList:true,subtree:true,characterData:true});
}
function schedule() {
 if (timer !== null) return;
 timer=setTimeout(()=>{timer=null;refresh();},60);
}
observer = new MutationObserver(schedule);
select.addEventListener('change',()=>{
 currency=codes.includes(select.value) ? select.value : 'USD';
 try {localStorage.setItem(preferenceKey,currency);} catch {}
 refresh();
});
refresh();
let needsFetch = true;
try { const cache=JSON.parse(localStorage.getItem(cacheKey)||'null'); needsFetch=!(cache && cache.expires>Date.now()); } catch {}
if (needsFetch) {
 const controller=new AbortController();
 const timeout=setTimeout(()=>controller.abort(),5000);
 fetch('https://open.er-api.com/v6/latest/INR',{signal:controller.signal,credentials:'omit'})
 .then(response=>{if(!response.ok)throw Error('FX unavailable');return response.json();})
 .then(data=>{
  if(data.result!=='success'||data.base_code!=='INR')return;
  const next={INR:1};
  for(const code of codes.filter(c=>c!=='INR')){
   const rate=1/Number(data.rates?.[code])-1;
   if(!Number.isFinite(rate)||rate<=0) return;
   next[code]=rate;
  }
  divisors=next;
  try {localStorage.setItem(cacheKey,JSON.stringify({divisors:next,expires:Date.now()+86400000}));} catch {}
  refresh();
 }).catch(()=>{}).finally(()=>clearTimeout(timeout));
}
})();